// extracted by mini-css-extract-plugin
module.exports = {"categories":"Categories_categories__2lcMj","inner":"Categories_inner__3i0me"};